import React from 'react'
import { VideoItem } from '../components/videoItem'
import get from 'lodash/get'

export default class VideoActivity extends React.Component {
  state = {
    themeOne: [],
    themeVideo: [],
    unLocked: false,
  }
  render() {
    const theme = get(this.props, 'theme.theme.themes')
    if (!this.props.theme.loading) {
      const themeOne = theme && theme[0]
      const themeVideo = themeOne.videoSources
      const themeId = get(this.props, 'match.params.themeId')
      const shareCount = get(this.props, 'shareActivity.shareActivity.hadShare', [])
      const videoPlayCount = get(this.props, 'shareActivity.shareActivity.videoPlayCount')
      return (
        <div
          style={{
            paddingLeft: '20px',
            paddingRight: '20px',
            // paddingTop: '10px',
            backgroundColor: 'white',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="theme-button">
              <span>{themeOne.title}</span>
            </div>
            <div className="theme-title">
              <h3>课程介绍</h3>
            </div>
            <span style={{ color: '#584F62' }}>
            本视频课包由北京中医药大学东方医院、糖尿病康复糖糖运动创始人、北京共同照护门诊联合独家制作，别的地方看不到哟。
            </span>
            <VideoItem props={this.props} themeVideo={themeVideo} unLocked={this.state.unLocked} />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="theme-title">
              <h3>解锁视频方法</h3>
            </div>
            <div className="theme-radius-wrapper">
              <span style={{ color: '#584F62' }}>
                点击下方『邀请好友』按钮，将活动分享给好友,即可获得全部视频观看权。快去分享吧～
              </span>
              <div
                onClick={() => {
                  window.postMessage(`OPEN_SHARED_PAGE_ON_RN:${themeId}`, '*')
                  setTimeout(() => this.setState({ unLocked: true }), 5000)
                }}
                style={{
                  height: '60px',
                  backgroundImage:
                  'url(' + require('./images/shareBtn.png') + ')',
                  backgroundRepeat: 'no-repeat',
                }}
              />
              <div style={{ textAlign: 'center', color: '#FF584C' }}>
                {`已经有${shareCount.length}人邀请成功`}
              </div>
              <div style={{ textAlign: 'center', color: '#FF584C' }}>
                {`视频累计播放${videoPlayCount}次`}
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return <div />
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/theme/components/videoActivity.js